import { useEffect, useState } from 'react';

export type Theme = 'system' | 'light' | 'dark';
const KEY = 'teknika-theme';

function apply(theme: Theme) {
  // With no data-theme, the stylesheet follows the browser's prefers-color-scheme.
  if (theme === 'system') delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = theme;
}

function stored(): Theme {
  const v = localStorage.getItem(KEY);
  return v === 'light' || v === 'dark' ? v : 'system';
}

/** The office's own light/dark preference, on top of the browser's. Saved per browser; chosen in the account menu. */
export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => stored());

  useEffect(() => apply(theme), [theme]);

  function setTheme(t: Theme) {
    if (t === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, t);
    setThemeState(t);
  }

  return { theme, setTheme };
}
